/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components'

interface PaymentTypeContainerProps {
  isActive?: boolean
  isBlocked?: boolean
}
export const PaymentTypeContainer = styled.div<PaymentTypeContainerProps>`
  ${({ isActive, isBlocked }) => css`
    padding: 16px;
    border: 1px solid #dddddd;
    background: ${isBlocked ? '#EEEEEE' : isActive ? '#F2F2F4' : '#FFFFFF'};
    border-radius: 16px;
    margin: 0 16px;
    margin-top: 16px;
    cursor: pointer;

    .payment_type_icon {
      width: 20px;
      height: 20px;
      color: ${isBlocked ? '#9E9E9E' : '#212121'};
    }

    .payment_type_header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      color: ${isBlocked ? '#9E9E9E' : '#212121'};
      font-size: 13px;
      font-weight: 400;
      line-height: 16px;
      text-align: left;

      .payment_type_header_left {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;
        cursor: pointer;
      }
    }

    .payment_type_body {
      display: ${isActive ? 'flex' : 'none'};
    }
    .react-select__single-value {
      width: 100%;
      padding-right: 8px;
    }
    .react-select__value-container {
      height: 38px;
    }
  `}
`

interface RadioButtonProps {
  isActive?: boolean
  isBlocked?: boolean
}
export const RadioButton = styled.button<RadioButtonProps>`
  ${({ isActive,isBlocked }) => css`
    width: 16px;
    height: 16px;
    background:${isBlocked ?'#DDDDDD' : '#ffffff'};
    border-radius: 8px;
    border: ${isBlocked ?'1px solid #DDDDDD' : isActive ? '4px solid #00AB50' : '1px solid #bdbdbd'};
  `}
`

export const PaymentTypeGrid = styled.div`
  display: grid;
  gap: 16px;

  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 0 !important;
  }
`
